import React from 'react';
import { CondensedLarge } from '@axiom/ui';
import type { FullCandidateAccount } from '@axiom/validation';

import { DateUtil } from '../../utils/date-util';

export const MyBenchCardExpectedChange = ({
  candidate,
}: {
  candidate: FullCandidateAccount;
}) => {
  return (
    <CondensedLarge name="EXPECTED_CHANGE">
      {candidate.soonestEngagementEndDate
        ? `Expected to change on ${DateUtil.displayDateFullYearShortMonth(candidate.soonestEngagementEndDate)}`
        : 'No expected change'}
    </CondensedLarge>
  );
};
